import { useState, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../core/store';
import { toggleSidebar as toggleSidebarAction, setTheme as setThemeAction, setSidebarOpen as setSidebarOpenAction } from '../../core/store/slices/uiSlice';

/**
 * Hook for managing UI state
 */
export const useUI = () => {
    const dispatch = useAppDispatch();
    const { sidebarOpen, theme } = useAppSelector((state) => state.ui);
    const [isProfileOpen, setIsProfileOpen] = useState(false);

    const toggleSidebar = useCallback(() => {
        dispatch(toggleSidebarAction());
    }, [dispatch]);

    const setTheme = useCallback((theme: 'light' | 'dark' | 'system') => {
        dispatch(setThemeAction(theme));
    }, [dispatch]);

    const toggleProfile = useCallback(() => {
        setIsProfileOpen((prev) => !prev);
    }, []);

    const setSidebarOpen = useCallback((open: boolean) => {
        dispatch(setSidebarOpenAction(open));
    }, [dispatch]);

    return {
        sidebarOpen,
        theme,
        isProfileOpen,
        toggleSidebar,
        setTheme,
        toggleProfile,
        setSidebarOpen,
    };
};
